import { render } from "./WizardStepper.vue?vue&type=template&id=bcf123ca"
import script from "./WizardStepper.vue?vue&type=script&lang=js"
export * from "./WizardStepper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__